import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { requestWithToken } from 'src/config';

@Injectable({
    providedIn: 'root'
})
export class ServiceListingService {

    async getServiceListing(searchLike: string, page: number, size: number, filter: any) {
        const p = {
            start: (page - 1) * size,
            size,
            ...(searchLike && searchLike.trim() !== '' ? { searchLike } : {}),
            ...filter
        }
        return requestWithToken(
            "POST",
            `/admin/services`, p
        )
    }

    async getServiceById(id: number) {
        return requestWithToken(
            "GET",
            `/admin/product/${id}`
        )
    }

    async addServiceToFavorites(productVariantId: number, type: number) {
        return requestWithToken(
            "PUT",
            `/user/product/tooglefavourite/${productVariantId}/${type}`,
            {}
        )
    }
    async getProductCategories() {
        return requestWithToken(
            "GET",
            `/masters/prodCategory`
        )
    }

    async getProductSubCategories(catId: string) {
        return requestWithToken(
            "GET",
            `/masters/subCategory?catId=${catId}`
        )
    }


    async getProductStatus() {
        return requestWithToken(
            "GET",
            `/masters/prodStatus`
        )
    }

    async getServiceType() {
        return requestWithToken(
            "GET",
            `/masters/serviceType`
        )
    }
    async getServiceDuration() {
        return requestWithToken(
            "GET",
            `/masters/duration`
        )
    }
    async uploadFile(payload: any) {
        return requestWithToken(
            "POST",
            "/user/document",
            payload
        )
    }
    async saveProduct(payload: any) {
        return requestWithToken(
            "POST",
            "/admin/product/save",
            payload
        )
    }
    async deleteProduct(productId: number) {
        return requestWithToken(
            "DELETE",
            `/admin/product/${productId}`
        )
    }
    async approveProduct(productId: number) {
        return requestWithToken(
            "PUT",
            `/admin/product/status?status=Approve&productId=${productId}`
        )
    }
    async rejectProduct(productId: number) {
        return requestWithToken(
            "PUT",
            `/admin/product/status?status=Reject&productId=${productId}`
        )
    }

    async getProductApproval() {
        return requestWithToken(
            "GET",
            `/masters/prodApprove`
        )
    }
    async getBusinessList(params:any){
        function createGetRequestUrl(baseUrl: string, params: any) {
            // Create a new URLSearchParams object
            const urlParams = new URLSearchParams();

            // Loop through the parameters and add them to the URLSearchParams
            for (const key in params) {
                if (params.hasOwnProperty(key) && params[key] !== undefined && params[key] !== null && params[key] !== "") {
                    urlParams.append(key, params[key]);
                }
            }

            // Combine the base URL and the parameters
            const fullUrl = baseUrl + (urlParams.toString() ? `?${urlParams.toString()}` : '');

            return fullUrl;
        }
        return requestWithToken(
            "GET",
            createGetRequestUrl(`/admin/master/business`, params)
        )
    }

    async statusUpdate(productId: number, status:string) {
        return requestWithToken(
            "PUT",
            `/admin/product/${productId}/status/${status}`
        )
    }
}
